import styled from "styled-components";

export const AccordionContent = styled.div`
  background-color: ${({ theme }) => theme.faqContent};
  border-radius: 8px;
  margin-bottom: 10px;
  transition: background-color 0.3s ease-in;
  width: 85%;

  .AccordionHeader {
    display: flex;
    height: 70px;
    margin: 0 2%;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
  }
  .AccordionTitle {
    flex: 1;
    font-size: 18px;
    color: ${({ theme }) => theme.text};
  }
  .AccordionIcon {
    margin-left: auto;
    font-size: 30px;
    color: #c2c41c;
  }
  .AccordionBody {
    padding: 10px;
    margin: 0 2%;
    font-size: 15px;
    word-spacing: 7px;
    color: ${({ theme }) => theme.text};
  }

  @media screen and (max-width: 768px) {
    .AccordionHeader {
      padding: 10px 12px;
    }
    .AccordionTitle {
      font-size: 14px;
    }
    .AccordionIcon {
      font-size: 18px;
      margin-left: 8px;
    }
    .AccordionBody {
      padding: 8px 12px;
      font-size: 14px;
    }
  }
`;
